import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'

const GeneralSaveButton = ({
  onClick,
  disabled,
  customWidth = '100%',
}: {
  onClick: () => void
  disabled: boolean
  customWidth?: string
}) => {
  const theme = useTheme()
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'))

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        sx={{
          width: customWidth,
          height: '100%',
          minHeight: 42,
          border: '1px solid',
          borderColor: 'rgb(78, 170, 237)',
          bgcolor: disabled ? '' : 'rgb(78, 170, 237)',
          zIndex: 20,
        }}
        // disabled={isRequesting || isRequested || !isValid}
        disabled={disabled}
        onClick={onClick}
        name="general-save-button"
        variant="outlined"
        color="primary"
      >
        <Typography>Save</Typography>
      </Button>
    </Box>
  )
}

export default GeneralSaveButton
